import React, {useState, useEffect} from 'react'
import './style.sass'
import './icons.sass'
import getCategoryMenu from '../../../services/getCategoryMenu'
import { decodeStorage, encodeStorage } from '../../../functions/storageBase64'

function MenuFirstLevel(props){
    const{
        catFisrt,
        nombre,
        seo,
        subcat
    } = props

    return(
        <dl className="menuFirstLevel">
            <dt>
                <a href={`/categoria/${catFisrt}/${seo}/`} className={`ico-${seo}`}>{nombre}</a>
                <dl className="menuSecondLevel">
                    <dt>
                        <dl className="menuThirdLevel">
                            <MenuSecondLevel subcat={subcat} />
                        </dl>
                    </dt>
                </dl>
            </dt>
        </dl>
    )
}


function MenuSecondLevel(props){
    const {
        subcat
    } = props

    const [subCategorias, setSubCategorias] = useState(subcat)
    useEffect(()=>{
        if(subcat){
            setSubCategorias(subcat)
        }
    },[subcat])

    return(
        subCategorias &&
            subCategorias?.map(({id_cat, nombre, seo, subcategorias, estatus, visible}) =>
                estatus !== 0 && visible !== 0
                    ? 
                        <dt className="more" key={id_cat}>
                            <a href={`/categoria/${id_cat}/${seo}/`}>{nombre}</a>
                            <MenuThirdLevel subcategorias={subcategorias} id_parent={id_cat} seo_parent={seo} />
                        </dt>
                    : null
            )
    )
}


function MenuThirdLevel(props){
    const {
        id_parent,
        seo_parent,
        subcategorias
    } = props

    const [subCatFinish, setSubCatFinish] = useState(subcategorias)

    useEffect(()=>{
        if(subcategorias){
            setSubCatFinish(subcategorias)
        }
    },[subcategorias])

    return(
        <ul>
            {subCatFinish &&
                subCatFinish.map(({id_cat, nombre, seo, estatus, visible}, index) =>
                    estatus !== 0 && visible !== 0
                        ?
                            index < 6
                                ? <li key={id_cat} className="alone marginTopCa"><a href={`/categoria/${id_cat}/${seo}/`}>{nombre}</a></li>
                                : 
                                    index === 6
                                        ? <li key={id_cat} className="alone marginTopCa"><a href={`/categoria/${id_parent}/${seo_parent}/`}>Ver más</a></li>
                                        : null
                        : null
                )
            }
        </ul>
    )
}


export function MenuCategoryHeader(){

    const [response, setResponse] = useState()
    const [categorias, setCategorias] = useState({})
    const [responseSorage, setResponseStorage] = useState([])
    const updateCategory = sessionStorage.getItem('updateCategory')
    const [responseV1, setResponseV1] = useState()
    
    //- Funcion que va al servicio de categorias
    useEffect( () => {
        if(!decodeStorage('categoryTree') || updateCategory === null){
            getCategoryMenu()
            .then(setResponse)
            sessionStorage.setItem('updateCategory',true)
        }else{
            //- Funcion que toma las categorias del storage
            setResponseStorage(decodeStorage('categoryTree'))
        }
    },[])

    useEffect( () => {
        if(response){
            if(response.data){
                if(response.data.length >= 2){
                    encodeStorage('categoryTree', response)
                    setResponseStorage(response)
                }
            }
        }
        else if(responseV1){
            if(responseV1.data){
                // console.log('')
            }
        }
    },[response, responseV1])
    
    //- Guarda en un estado la respuesta y evalua que sea 200 si no manda el error
    useEffect(()=>{
        if(responseSorage){
            if(responseSorage?.statusCode === 200){
                if(typeof(responseSorage?.data) === 'object'){
                    setCategorias({
                        'categoriasMenu': responseSorage?.data
                    })
                }
                else{
                    setCategorias({})
                }
            }
        }
        else if(responseSorage?.statusCode !== undefined){
            setCategorias({})
        }
        
    },[responseSorage])

    // console.log('categorias: ',categorias   )
    
    return(
        <div className="menuHeader">
            <div className="subMenu">
                {responseSorage &&
                    responseSorage?.statusCode === 200
                        ?
                            categorias?.categoriasMenu && categorias?.categoriasMenu.length > 0 &&
                                <>
                                    {
                                        categorias?.categoriasMenu?.map(({nombre, icon, seo, id_cat, subcat, estatus, visible}) => 
                                            estatus !== 0  && visible !== 0
                                                ?
                                                    <MenuFirstLevel
                                                        key={id_cat}
                                                        catFisrt={id_cat}
                                                        nombre={nombre}
                                                        icon={icon}
                                                        seo={seo}
                                                        subcat={subcat}
                                                    />
                                                :
                                                    null
                                        )
                                    }
                                </>
                        : null
                }
                
            </div>
        </div>
    )
}